import { LicenseManager } from '../../../../managers/License.manager';
import { Component, OnInit, Input } from '@angular/core';
import { ssApiService } from '../../../../services/ss-api.service';
import { LicenseTransferLogArray } from '../../../../models/domain/license.transfer.log';
import { LicensePCItemArray } from '../../../../models/domain/license.pc.item';

@Component({
	selector: 'license-transfer-details',
	templateUrl: './transfer.details.component.html',
	styleUrls: ['./transfer.details.component.scss']
})

export class LicenseTransferDetailsComponent implements OnInit {
	IsBusy: boolean = false;

	@Input('licenseManager') licenseManager: LicenseManager;
	@Input('Subscriptions') Subscriptions;

	@Input('TransferDetails') TransferDetails: LicenseTransferLogArray = new LicenseTransferLogArray();

	constructor(private API: ssApiService) { }

	ngOnInit() {

		



	}


	limitTimeToDays(limitTime: any): string {

		let baseMin = limitTime;
		let Days = Math.floor(baseMin / 60 / 24);
		baseMin -= Days * 60 * 24;
		let Hours = Math.floor(baseMin / 60);
		baseMin -= Hours * 60;
		let Minutes = baseMin;

		return Days + 'd ' + Hours + 'h ' + Minutes + 'm';

	}
	

}
